import App from './KRDiagramApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iKRDiagram', <App />);
